import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output
} from '@angular/core';

import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { MatExpansionModule, MatExpansionPanel } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FormGroup } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { SharedTranslateModule } from '../../../utils/sharedTranslateModule';

@Component({
    selector: 'app-header',
    templateUrl: './fleetheader.component.html',
    imports: [SharedTranslateModule, MatTableModule, MatInputModule, MatExpansionModule, MatToolbarModule, MatNativeDateModule, MatDatepickerModule, MatFormFieldModule, MatIconModule, MatMenuModule, MatAutocompleteModule, MatFormFieldModule,],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FleetHeaderComponent {
  @Output() menuToggled = new EventEmitter<boolean>();

  user: string = 'Enea';

  // constructor(private authService: AuthService) { }

  logout(): void {
  }
}
